export default __webpack_public_path__ + "static/dokter-van-peltlaan-5-bergen-08cf778271ea3547695d43a3e7f12eb3.webp";